import { getCssVar } from '../../util/generic';

/**
 * Default tippy options
 * @type {Partial<import('tippy.js').Props>}
 */
export const defaultOptions = {
	allowHTML: true,
	// animation: 'scale',
	arrow: false,
	inertia: true,
	interactive: true,
	interactiveBorder: 0,
	interactiveDebounce: 75,
	duration: 0,
	maxWidth: 'none',
	offset: [0, 0],
	popperOptions: {
		modifiers: [
			{ name: 'flip', enabled: false },
			{
				name: 'applyZIndex',
				enabled: true,
				phase: 'beforeWrite',
				fn: (data) => {
					data.state.styles.popper.zIndex = getCssVar('zindex-menu', '1000');
				},
			},
		]
	},
	theme: 'light',
};

/**
 * @param {*} baseOpt
 * @param {*} newOpt
 */
export const overloadTippyOptions = (baseOpt, newOpt) => {

	for (const [key, value] of Object.entries(newOpt)) {

		// Overload functions
		if ((key in baseOpt) && (typeof value === 'function') && (typeof baseOpt[key] === 'function')) {
			const baseFn = baseOpt[key];
			const newFn = value;
			baseOpt[key] = (...args) => {
				baseFn.apply(null, args);
				newFn.apply(null, args);
			};
		}
		// Overwrite prop
		else {
			baseOpt[key] = value;
		}
	}

	return baseOpt;
};

// Tippy modifier for the tabbed submenus
export const tabbedMenuModifier = (data) => {
	data.state.styles.popper = {
		// Merge with default popper styles
		...data.state.styles.popper,

		position: 'static',
		transform: 'none',
	};
};

// Tippy modifier for right drawer display type
export const rightDrawerModifier = (data) => {
	const $tippyBox = $(data.state.elements.popper).find('.tippy-box');
	const $tippyContent = $(data.state.elements.popper).find('.tippy-content');
	$tippyBox.css({
		'width': '100%',
		'height': '100%',
	});

	$tippyContent.css({
		'width': '100%',
		'height': '100%',
		'display': 'flex',
		'justify-content': 'center',
		'align-items': 'center',
	});

	data.state.styles.popper = {
		position: 'fixed',
		top: 0,
		right: 0,
		bottom: 0,
		left: 'unset',
		width: window.matchMedia('(min-width: 564px)').matches ? '430px' : '100vw',
		display: 'flex',
	};
};

/**
 * Handle close action from the header, either by Escape key press or other event.
 *
 * @param {JQuery.Event} event
 * @param {import('tippy.js').Instance} instance
 * @param {function=} callback - The callback that handles the response.

 */
export const closeAction = (event, instance, callback) => {
	if (event.type === 'keyup') {
		if (event.key === 'Escape') {
			callback && callback() || instance.hide();
		}
	}
	else if (event.type === 'mouseleave') {
		// @ts-ignore
		callback && callback() || instance.hideWithInteractivity(event.originalEvent);
	}
	else {
		callback && callback() || instance.hide();
	}
};
